import type React from "react";
import { useRef, useState } from "react";
import {
	HoverCard,
	HoverCardContent,
	HoverCardTrigger,
} from "@/components/ui/hover-card";
import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from "@/components/ui/popover";
import { cn } from "@/lib/utils";
import { useHideOnClickOutside } from "./hooks/useHideOnClickOutside";

type Props = {
	content: React.ReactNode;
	trigger: React.ReactNode;
	disabled: boolean;
	width?: number;
	align?: "start" | "center" | "end";
	side?: "top" | "right" | "bottom" | "left";
	sideOffset?: number;
	top?: number;
	left?: number;
	className?: string;
};

export const HoverCardWrapper: React.FC<Props> = ({
	content,
	trigger,
	disabled,
	width = 150,
	align = "start",
	side = "bottom",
	sideOffset = 4,
	top = 0,
	left = 100,
	className,
}) => {
	const [isPopover, setIsPopover] = useState(false);
	const contentRef = useRef<HTMLDivElement>(null);

	useHideOnClickOutside({
		contentRef,
		setIsPopover,
		open: isPopover,
	});

	if (!disabled) {
		return trigger;
	}

	return (
		<div
			data-testid="hover-card-wrapper"
			className={cn("bg-popover", className)}
		>
			<HoverCard>
				<HoverCardTrigger onClick={() => setIsPopover(!isPopover)}>
					{trigger}
				</HoverCardTrigger>

				{!isPopover && content && (
					<HoverCardContent
						className={`w-[${width}px] mt-5 top-[${top}px] left-[${left}px] hhh`}
						align={align}
						side={side}
						sideOffset={sideOffset}
					>
						{content}
					</HoverCardContent>
				)}
			</HoverCard>

			{isPopover && content && (
				<Popover open={isPopover}>
					<PopoverTrigger className={"opacity-0 absolute h-{0px} w-{0px}"}>
						{trigger}
					</PopoverTrigger>

					<PopoverContent
						ref={contentRef}
						align={align}
						className={`w-[${width}px]  top-[${top}px] left-[${left}px]`}
						side={side}
						sideOffset={sideOffset}
					>
						{content}
					</PopoverContent>
				</Popover>
			)}
		</div>
	);
};
